module.exports = __webpack_public_path__ + "facebook.png?3079d21aeaee247258e7ac20ad6eddd5";